import FeedbackSuccessLogin from '../../components/molecules/feedbacks/FeedbackSuccessLogin.vue'
import FeedbackErrorLogin from '../../components/molecules/feedbacks/FeedbackErrorLogin.vue'
import FeedbackSuccessLogout from '../../components/molecules/feedbacks/FeedbackSuccessLogout.vue'

export default {
  components: {
    FeedbackSuccessLogin,
    FeedbackErrorLogin,
    FeedbackSuccessLogout
  }
}
